module.exports = __webpack_public_path__ + "img/menu-bg2.57026c85.png";